import { render, staticRenderFns } from "./RegionAttribute.vue?vue&type=template&id=31864924"
import script from "./RegionAttribute.vue?vue&type=script&lang=js"
export * from "./RegionAttribute.vue?vue&type=script&lang=js"
import style0 from "./RegionAttribute.vue?vue&type=style&index=0&id=31864924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports